import {
  DashboardDetailsClient,
  IDashboardDetailsClient
} from "@material-dev/insights-portal-ui-components/lib/api-clients/ShellApiClient";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {LoadingState} from "../../types";
import { initialDashboardState } from "./dashboardState";

const appName = process.env.REACT_APP_NAME ?? "datamanager";
const projectsClient: IDashboardDetailsClient = new DashboardDetailsClient(process.env.REACT_APP_SHELL_API_URL);

export const getDashboardPublicDetails = createAsyncThunk("dashboard/getDashboardPublicDetails", async () => {
  const result = await projectsClient.getDashboardDetails(appName);
  return result;
});

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialDashboardState,
  reducers: {
    openHelpDrawer: (state) => {
      state.helpDrawerOpen = true;
    },
    closeHelpDrawer: (state) => {
      state.helpDrawerOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDashboardPublicDetails.fulfilled, (state, action) => {
      state.dashboardDetails = action.payload;
      state.loading = LoadingState.succeed;
    });
    builder.addCase(getDashboardPublicDetails.rejected, (state) => {
      state.dashboardDetails = null;
      state.loading = LoadingState.failed;
    });
    builder.addCase(getDashboardPublicDetails.pending, (state) => {
      state.dashboardDetails = null;
      state.loading = LoadingState.pending;
    });
  },
});

export const {
  openHelpDrawer,
  closeHelpDrawer,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
